import { useEffect, useMemo, useState } from "react";

const PAGE_SIZE = 10;

export const usePagination = <T>(items: T[]) => {
  const [currentPage, setCurrentPage] = useState(0);
  const totalPages = Math.ceil(items.length / PAGE_SIZE);

  useEffect(() => {
    setCurrentPage(0);
  }, [items]);

  const page = useMemo(() => {
    const start = currentPage * PAGE_SIZE;
    return items.slice(start, start + PAGE_SIZE);
  }, [items, currentPage]);

  const nextPage = () => {
    console.log(currentPage);
    if (currentPage < totalPages - 1) {
      setCurrentPage((prev) => prev + 1);
    } else {
      setCurrentPage(0); // Reset to first page if at the end
    }
  };

  const prevPage = () => {
    if (currentPage > 0) {
      setCurrentPage((prev) => prev - 1);
    } else {
      setCurrentPage(totalPages - 1); // Go to last page if at the first
    }
  };

  return {
    page,
    nextPage,
    prevPage,
    totalPages,
    currentPage,
    itemsPerPage: PAGE_SIZE,
  };
};
